import module from './gift-list.module';
import './gift-list.controller';
import './services/gift-list.service';
import './gift-list.style.scss';

export default module.name;